import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";

const NAV = [
  { href: "#services", label: "Services" },
  { href: "#approach", label: "Approach" },
  { href: "#about", label: "About" },
  { href: "#faq", label: "FAQ" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/80 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center group"
        >
          <img
            src="/logo.png"
            alt="Black Rock Hospitality"
            className="h-12 md:h-14 w-auto transition-opacity group-hover:opacity-90"
          />
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className="text-sm text-white/70 hover:text-[#C2A878] transition-colors tracking-wide"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          href="#audit"
          data-testid="header-cta-audit"
          className="hidden md:inline-flex items-center bg-[#C2A878] hover:bg-[#D4AF37] text-[#050505] px-5 py-3 text-xs font-semibold tracking-[0.18em] uppercase transition-all duration-300"
        >
          Book audit
        </a>

        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button
              data-testid="mobile-menu-trigger"
              className="md:hidden p-2 text-white"
              aria-label="Open menu"
            >
              <Menu className="w-6 h-6" />
            </button>
          </SheetTrigger>
          <SheetContent
            side="right"
            className="bg-[#050505] border-l border-white/10 text-white w-[85vw] sm:w-[420px]"
          >
            <SheetTitle className="sr-only">Navigation</SheetTitle>
            <SheetDescription className="sr-only">
              Black Rock Hospitality site navigation
            </SheetDescription>
            <div className="flex flex-col h-full">
              <div className="flex items-center justify-between mb-12">
                <img
                  src="/logo.png"
                  alt="Black Rock Hospitality"
                  className="h-12 w-auto"
                />
                <button
                  data-testid="mobile-menu-close"
                  onClick={() => setOpen(false)}
                  className="p-2"
                  aria-label="Close menu"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <nav className="flex flex-col gap-6">
                {NAV.map((n) => (
                  <a
                    key={n.href}
                    href={n.href}
                    onClick={() => setOpen(false)}
                    data-testid={`mobile-nav-link-${n.label.toLowerCase()}`}
                    className="font-serif text-3xl text-white hover:text-[#C2A878] transition-colors"
                  >
                    {n.label}
                  </a>
                ))}
              </nav>
              <div className="mt-auto pt-8 border-t border-white/10">
                <a
                  href="#audit"
                  onClick={() => setOpen(false)}
                  data-testid="mobile-cta-audit"
                  className="block text-center bg-[#C2A878] hover:bg-[#D4AF37] text-[#050505] px-6 py-4 text-xs font-semibold tracking-[0.18em] uppercase transition-all"
                >
                  Book audit
                </a>
              </div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
